import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-more-dot',
  templateUrl: './icon-more-dot.component.html',
  styleUrls: ['./icon-more-dot.component.scss']
})
export class IconMoreDotComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
